import PersonIcon from '@atlaskit/icon/core/person';
import * as React from 'react';

export function SvgUser() {
  return <PersonIcon label="" testId="ads-refreshed-icon" />;
}
